import React, { useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../../utils/colors";
import Logo from "../../logo";
import PrimaryButton from "../../buttons/primary-button";
import { Spin as Hamburger } from "hamburger-react";
import Modal from "components/modal";
import UploadMediaModal from "components/modal/modals/upload-media-modal";
import Typography from "components/typography";

import SelectArtist from "./selectArtist";
import { GetActiveArtist } from "services/user/getUser";

interface IProps {
  setOpenSidebar: (value: boolean) => void;
}
const DashboardNavbar = ({ setOpenSidebar }: IProps) => {
  const [uploadModal, setUploadModal] = useState(false);
  const artist = GetActiveArtist();

  const UploadDisabled = useMemo(() => {
    if (!artist) {
      return true;
    }
    return false;
  }, [artist]);

  return (
    <Container>
      <LogoContainer>
        <Logo width="8rem" />
      </LogoContainer>
      <ArtistContainer>
        <SelectArtist />
      </ArtistContainer>
      <Button>
        <PrimaryButton
          inset
          text="Upload"
          sparkle
          disabled={UploadDisabled}
          onClick={() => setUploadModal(true)}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5.23744 15.8333C3.265 15.8333 1.66602 14.2532 1.66602 12.3039C1.66602 10.3547 3.265 8.7745 5.23744 8.7745C5.47421 8.7745 5.7056 8.79725 5.92948 8.84075M5.92948 8.84075C5.73857 8.3315 5.63427 7.78073 5.63427 7.20588C5.63427 4.60689 7.76625 2.5 10.3962 2.5C12.8459 2.5 14.8636 4.32809 15.1286 6.67915M5.92948 8.84075C6.39984 8.932 6.83708 9.1145 7.22157 9.36883M11.9835 6.68934C12.4799 6.51593 13.0142 6.42157 13.5708 6.42157C14.1163 6.42157 14.6404 6.51223 15.1286 6.67915M15.1286 6.67915C16.9935 7.31687 18.3327 9.06758 18.3327 11.1274C18.3327 13.3832 16.7265 15.2684 14.5827 15.7268"
                stroke="#131313"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M10.0007 13.3335V18.3335M10.0007 13.3335L11.6673 15.0002M10.0007 13.3335L8.33398 15.0002"
                stroke="#131313"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          }
          iconPosition="right"
        />
      </Button>
      {/* mobile */}
      <MobileNavRight>
        <MobileUploadButton onClick={() => setUploadModal(true)}>
          <Typography color={Colors.yellow500} weight="medium" mr="1">
            Upload
          </Typography>
          <MobileUploadButtonIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M5.23842 15.8333C3.26598 15.8333 1.66699 14.2532 1.66699 12.3039C1.66699 10.3547 3.26598 8.7745 5.23842 8.7745C5.47518 8.7745 5.70658 8.79725 5.93046 8.84075M5.93046 8.84075C5.73954 8.3315 5.63524 7.78073 5.63524 7.20588C5.63524 4.60689 7.76723 2.5 10.3972 2.5C12.8469 2.5 14.8646 4.32809 15.1296 6.67915M5.93046 8.84075C6.40082 8.932 6.83806 9.1145 7.22255 9.36883M11.9845 6.68934C12.4809 6.51593 13.0152 6.42157 13.5717 6.42157C14.1173 6.42157 14.6414 6.51223 15.1296 6.67915M15.1296 6.67915C16.9945 7.31687 18.3337 9.06758 18.3337 11.1274C18.3337 13.3832 16.7275 15.2684 14.5837 15.7268"
                stroke="#FEA101"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M9.99967 13.3335V18.3335M9.99967 13.3335L11.6663 15.0002M9.99967 13.3335L8.33301 15.0002"
                stroke="#FEA101"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </MobileUploadButtonIcon>
        </MobileUploadButton>
        <HamburgerContainer>
          <Hamburger
            size={20}
            color={Colors.white100}
            onToggle={(toggled) => {
              if (toggled) {
                setOpenSidebar(true);
              } else {
                setOpenSidebar(false);
              }
            }}
          />
        </HamburgerContainer>
      </MobileNavRight>

      {/* modal */}
      <Modal isActive={uploadModal} closeModal={() => setUploadModal(false)}>
        <UploadMediaModal close={() => setUploadModal(false)} />
      </Modal>
    </Container>
  );
};

export default DashboardNavbar;

const Container = styled.div`
  width: 100%;
  padding: 1.4rem 6.4rem 1.4rem 4rem;
  border-bottom: 1px solid ${Colors.grey700};
  background: #0d0d0d;
  box-shadow: 0px -7px 14px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  height: 100%;
  @media only screen and (max-width: 769px) {
    justify-content: space-between;
    padding: 1.2rem 2.4rem;
  }
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: end;
`;

const ArtistContainer = styled.div`
  margin-left: auto;
  position: relative;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const Button = styled.div`
  margin-left: 1.6rem;
  width: fit-content;
  @media only screen and (max-width: 769px) {
    display: none;
  }
`;

const MobileNavRight = styled.div`
  display: none;
  align-items: center;
  @media only screen and (max-width: 769px) {
    display: flex;
  }
`;
const MobileUploadButton = styled.div`
  margin-right: 1.6rem;
  padding: 1.1rem 1.6rem;
  display: flex;
  align-items: center;
`;

const MobileUploadButtonIcon = styled.div`
  width: 2rem;
  height: 2rem;
`;

const HamburgerContainer = styled.div``;
